import * as React from "react"
import { Link } from "react-router-dom"
import { Action, mk_widget, Widget } from "widgets-for-react"
import { LoginState } from "../state"
import { MinimalLoginWidgetData, update_state_with_route } from "../login";
import { LoginFlowStyle } from "./style.mod";
import { getClassName } from "../../utils/utils.mod";
import i18next = require("i18next");

export function page_404<a, extra_user_info>(
  data:  MinimalLoginWidgetData<a, extra_user_info>,
  options?: { style?: LoginFlowStyle; key?: string }
) : (_: string) => Widget<Action<LoginState<a, extra_user_info>>> {
  return (rootpath:string): Widget<Action<LoginState<a, extra_user_info>>> => {
    return mk_widget({
      run: (setState: (_: Action<LoginState<a, extra_user_info>>) => void) => {
        return (
          <section className={getClassName(options, "block_classname", "container")} key="login-widget-404">
            <header className={getClassName(options, "header_classname", "mb-4")}>
              <Link className="header__link" to={`${rootpath}`}>
                <h1 className={getClassName(options, "title_classname", "mb-4")}>{i18next.t(`loginflow:page_404.title`)}</h1>
                <svg className="header__logo" width="120" height="32" aria-hidden="true">
                  <use xlinkHref="#icon--logo" />
                </svg>
              </Link>
            </header>

            <div className={getClassName(options, "inner_classname", "py-5")}>
              <div className={getClassName(options, "form_classname", "")}>
                <div className={getClassName(options, "form_inner_classname", "")}>
                  <p className={getClassName(options, "intro_classname", "lead")}>{i18next.t(`loginflow:page_404.text`)}</p>
                  <footer className={getClassName(options, "form_actions_classname", "")}>
                    {data.without_browserRouter
                      ? <button
                          type="button"
                          className={getClassName(options, "clickable_primary_classname", "btn btn-dark")}
                          onClick={() => setState(update_state_with_route({ kind: "home" }, data))}
                        >
                          {i18next.t(`loginflow:page_404.submit`)}
                        </button>
                      : <Link
                          to={rootpath}
                          key="reset_pass_success_signin"
                          className={getClassName(options, "clickable_primary_classname", "btn btn-dark")}
                        >
                          {i18next.t(`loginflow:page_404.submit`)}
                        </Link>
                    }
                  </footer>
                </div>
              </div>
            </div>
          </section>
        )
      }
    })
  }
}
